<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="2">
        <v-menu
          ref="menuDateFrom"
          v-model="menuDateFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="dateFrom | dateFormat"
              :label="`${$t('ORDERS.DATE_ENTERED_FROM')} `"
              append-icon="mdi-calendar"
              clearable
              readonly
              role="button"
              autocomplete="nope"
              @click:clear="clear_from"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            ref="picker"
            v-model="dateFrom"
            min="1940-01-01"
            first-day-of-week="1"
            @change="saveDatefrom"
          ></v-date-picker>
        </v-menu>

        <v-menu
          ref="menuDateTo"
          v-model="menuDateTo"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="dateTo | dateFormat"
              :label="`${$t('ORDERS.DATE_ENTERED_TO')} `"
              append-icon="mdi-calendar"
              clearable
              readonly
              role="button"
              autocomplete="nope"
              @click:clear="clear_to"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            ref="picker"
            v-model="dateTo"
            :min="dateFrom || '1940-01-01'"
            first-day-of-week="1"
            @change="saveDateto"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="currFilters.order_number"
          :label="`${$t('ORDERS.ORDER_NUMBER')} `"
          :search-input.sync="order_number"
          :items="order_numbers"
          :loading="loading"
          item-text="name"
          item-value="name"
          :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
          clearable
        ></v-autocomplete>

        <v-select
          v-model="currFilters.service"
          :items="services"
          item-text="title"
          item-value="id"
          :label="`${$t('ORDERS.SERVICE_NAME')} `"
          :loading="loading"
          chips
          small-chips
          multiple
          clearable
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="remove(data.item, currFilters.service)"
            >
              {{ data.item.title }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="currFilters.building_complex"
          :label="$t('BUILDING_COMPLEXES.ITEM')"
          :items="buildingComplexes"
          :loading="loading"
          item-text="name"
          item-value="id"
          :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
          chips
          small-chips
          multiple
          clearable
          deletable-chips
        />

        <group-select
          v-model="currFilters.group"
          name="group"
          chips
          small-chips
          multiple
          clearable
          :label="$t('ITEM.GROUP')"
        />
      </v-col>
      <v-col>
        <v-autocomplete
          v-model="currFilters.source"
          :label="`${$t('ORDERS.SOURCE')} `"
          :search-input.sync="source"
          :items="sources"
          :loading="loading"
          item-text="name"
          item-value="name"
          :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
          clearable
        ></v-autocomplete>
        <v-autocomplete
          v-model="currFilters.customer"
          :label="`${$t('ORDERS.CUSTOMER')} `"
          :search-input.sync="customer"
          :items="customers"
          :loading="loading"
          item-text="name"
          item-value="name"
          :no-data-text="$t('TASKS.NO_DATA_FILTER_TEXT')"
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="currFilters.order_type"
          :items="order_types"
          item-text="name"
          item-value="id"
          :label="`${$t('ORDERS.TYPE')} `"
          :loading="loading"
          clearable
        >
        </v-select>
        <v-select
          v-model="currFilters.status"
          :items="statuses"
          item-text="name"
          item-value="id"
          :label="`${$t('ITEM.STATUS')} `"
          :loading="loading"
          chips
          small-chips
          multiple
          clearable
        >
          <template v-slot:selection="data">
            <v-chip
              v-bind="data.attrs"
              :input-value="data.selected"
              close
              @click="data.select"
              @click:close="remove(data.item, currFilters.status)"
            >
              {{ data.item.name }}
            </v-chip>
          </template>
        </v-select>
        <v-row>
          <v-col cols="12" class="text-right">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="grey" depressed outlined @click="reset" v-on="on">
                  <v-icon>mdi-filter-remove</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
            </v-tooltip>
            <v-btn
              class="ml-4"
              color="primary"
              depressed
              @click.prevent="setFilters"
            >
              {{ $t('BUTTON.FIND') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { dateFormat } from '@/modules/_global/filters';
import { mapActions, mapState } from 'vuex';
import { debounce, cloneDeep, isEmpty } from 'lodash';
import GroupSelect from '@/modules/services/components/GroupSelect';
import listFilters from '@/modules/_global/mixins/list-filters';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'OrdersFilterForm',
  components: { GroupSelect },
  filters: {
    dateFormat
  },

  mixins: [listFilters],

  props: {},

  data() {
    return {
      expensiveFunc: null,
      unwatch: null,
      delay: 0,
      currFilters: {},

      menuDateFrom: false,
      dateFrom: null,
      menuDateTo: false,
      dateTo: null,

      order_number: null,
      order_numbers: [],

      source: null,
      sources: [],

      customer: null,
      customers: [],

      services: [],
      service: [],

      statuses: [],
      status: [],

      buildingComplexes: [],
      building_complex: []
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('planning', ['taskStatuses']),
    ...mapState('order', ['filters']),
    debouncedRequest() {
      return debounce(this.expensiveFunc, this.delay);
    },
    order_types() {
      return [
        { id: 0, name: this.$t('ORDERS.TYPES.ALL') },
        { id: 1, name: this.$t('ORDERS.TYPES.ONE_TIME') },
        { id: 2, name: this.$t('ORDERS.TYPES.REGULAR') }
      ];
    }
  },

  watch: {
    dateTo(val) {
      if (val) {
        this.currFilters = { ...this.currFilters, date_entered_to: val };
      } else {
        this.currFilters.date_entered_to = null;
      }
    },

    dateFrom(val) {
      if (val) {
        this.currFilters = { ...this.currFilters, date_entered_from: val };
      } else {
        this.currFilters.date_entered_from = null;
      }
    },

    customer(val) {
      if (val !== this.currFilters.customer && !isEmpty(val)) {
        this.expensiveFunc = this.getDataCustomers;
        this.debouncedRequest();
      }
    },

    source(val) {
      if (val !== this.currFilters.source && !isEmpty(val)) {
        this.expensiveFunc = this.getDataSources;
        this.debouncedRequest();
      }
    },

    order_number(val) {
      if (val !== this.currFilters.order_number && !isEmpty(val)) {
        this.expensiveFunc = this.getDataOrderNumbers;
        this.debouncedRequest();
      }
    }
  },

  mounted() {
    if (!isEmpty(this.filters)) {
      this.currFilters = cloneDeep(this.filters);
      this.customer = this.filters.customer;
      this.getDataCustomers();
      this.source = this.currFilters.source;
      this.getDataSources();
      this.order_number = this.currFilters.order_number;
      this.getDataOrderNumbers();
      this.dateFrom = this.currFilters.date_entered_from;
      this.dateTo = this.currFilters.date_entered_to;
    }

    this.setFilters();
    this.setData();
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.setFilters();
          this.setData();
        }
      }
    );
    this.setDelay(500);
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    ...mapCacheActions('order', ['getOrderStatuses']),
    ...mapActions('service', ['retrieveEmployeeServices']),
    ...mapActions('building_complex', ['retrieveBuildingComplexesList']),
    ...mapActions('order', [
      'getFilteredOrderNumbers',
      'getFilteredSources',
      'getFilteredCustomers'
    ]),

    setData() {
      this.retrieveEmployeeServices().then(({ data }) => {
        this.services = data.data;
      });
      this.getOrderStatuses().then(({ data }) => {
        this.statuses = data.data;
      });
      this.retrieveBuildingComplexesList().then(({ data }) => {
        this.buildingComplexes = data.data;
      });
    },

    clear_from() {
      this.dateFrom = null;
    },
    clear_to() {
      this.dateTo = null;
    },

    saveDatefrom(date) {
      this.$refs.menuDateFrom.save(date);
    },

    saveDateto(date) {
      this.$refs.menuDateTo.save(date);
    },

    expensiveOperation: function() {
      return this.debouncedRequest();
    },

    setDelay(v) {
      this.delay = v;
    },

    getDataCustomers() {
      this.customer = this.customer ? this.customer.trim() : this.customer;

      this.getFilteredCustomers({ search: this.customer })
        .then(({ data }) => {
          this.customers = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    getDataOrderNumbers() {
      this.order_number = this.order_number
        ? this.order_number.trim()
        : this.order_number;

      this.getFilteredOrderNumbers({ search: this.order_number })
        .then(({ data }) => {
          this.order_numbers = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    getDataSources() {
      this.getFilteredSources({ search: this.source })
        .then(({ data }) => {
          this.sources = data.data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    remove(item, obj) {
      const index = obj.indexOf(item.id);
      if (index >= 0) obj.splice(index, 1);
    },
    reset() {
      this.menuDateFrom = false;
      this.dateFrom = null;
      this.menuDateTo = false;
      this.dateTo = null;

      this.order_number = null;

      this.source = null;

      this.customer = null;

      this.service = [];

      this.status = [];

      this.building_complex = [];

      this.currFilters = {};

      this.setFilters();
    }
  }
};
</script>
